import React from "react";
import "./style.css";
import { Link } from "react-router-dom";

function Header({ ads }) {
  const scrollAmount = 500;

  const handleScroll = () => {
    window.scrollBy({
      top: scrollAmount,
      behavior: "smooth",
    });
  };
  const ad = ads.length > 0 ? ads[0] : null;

  // Set background image only if an ad is available
  const headerStyle = ad ? { backgroundImage: `url(${ad.img_url})` } : {};

  return (
    <section id="hero" style={headerStyle}>
      {ad ? (
        <>
          <h4>{ad.title}</h4>
          <h2>City Gamers</h2>
          <h2 className="and">&</h2>
          <h2>Electronics World</h2>
          <p>{ad.sub_title}</p>
          <Link className="shopNow" onClick={handleScroll}>
            Shop Now
          </Link>
        </>
      ) : (
        <p>No banner ads available</p>
      )}
    </section>
  );
}

export default Header;
